module.exports = __webpack_public_path__ + "img/menu-bottom.598e8ffb.png";